import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faLinkedin,
  faXTwitter,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";

export default function Footer() {

    return (
        <footer>
            <div style={{textAlign: "center", marginBottom: "80px"}}  className="appear">
                <h1 style={{marginBottom: "40px"}}>Ready to be part of the next luxury marketplace?</h1>

                <a className="download-link-footer" href="/partner" style={{textDecoration: "none", marginRight:"30px"}}><span className="header-download">Invest / Partner</span></a>
                <a className="download-link-footer" href="/#testApp" style={{textDecoration: "none"}}><span className="header-download" style={{backgroundColor:"white", color:"black"}}>Test Prototype</span></a>
            </div> 
            <div className="footer-bottom-flex"> 
                <div>
                    <a className="logo footer-logo" href="/">NV</a>
                </div>
                <div className="footer-links-flex">
                    <a href="mailto:nkechukwu@nv.luxury">Support</a>
                    <a href="/termsandconditions">Terms & Conditions</a>
                    <a href="/privacypolicy">Privacy Policy</a>
                    <a href="/copyright">Copyright Policy</a>

                </div>

                <div className="footer-socials-flex">
                    <a href="https://www.instagram.com/nvluxuryy?igsh=MXJkOTE1aXhkZXVudQ%3D%3D&utm_source=qr" aria-label="Instagram" target="_blank">
                        <FontAwesomeIcon icon={faInstagram} style={{height: "2em"}} />
                    </a>

                    <a href="https://www.linkedin.com/company/nvluxury/" aria-label="LinkedIn" target="_blank">
                        <FontAwesomeIcon icon={faLinkedin} style={{height: "2em"}} />
                    </a>

                    <a href="https://x.com/nvluxuryy?s=21" aria-label="X" target="_blank">
                        <FontAwesomeIcon icon={faXTwitter} style={{height: "2em"}} />
                    </a>

                    <a href="https://facebook.com/yourprofile" aria-label="Facebook" target="_blank">
                        <FontAwesomeIcon icon={faFacebook} style={{height: "2em"}} />
                    </a>
                </div>
            </div>

            <div className="copyright-div">
                <p>© 2026 Nkechukwu's Vision LTD (NV). All rights reserved.</p>
            </div>
        </footer>
    )
}

